import { ORGANISATION_GENERAL_TYPES } from '@joc/api-gateway';

export const ORGANISATION_GENERAL_TYPE_LABELS: Record<ORGANISATION_GENERAL_TYPES | string, string> = {
	[ORGANISATION_GENERAL_TYPES.OTHER]: 'Organization',
	[ORGANISATION_GENERAL_TYPES.SCHOOL]: 'School',
	[ORGANISATION_GENERAL_TYPES.GROUP]: 'Group',
};

export const ORGANISATION_TYPE_OPTIONS: Array<{ label: string; value: ORGANISATION_GENERAL_TYPES }> = [
	{ label: 'Organization', value: ORGANISATION_GENERAL_TYPES.OTHER },
	{ label: 'School', value: ORGANISATION_GENERAL_TYPES.SCHOOL },
	{ label: 'Group', value: ORGANISATION_GENERAL_TYPES.GROUP },
];

export const formatOrganisationGeneralType = (type?: ORGANISATION_GENERAL_TYPES | string): string => {
	if (!type) return '';
	return ORGANISATION_GENERAL_TYPE_LABELS[type] || type;
};
